import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: true,
  name: 'phoneNumber',
})
export class PhoneNumberPipe implements PipeTransform {
  public transform(value: string): any {
    if (value) {
      value = value.replace(/\D/g, '');
      const areaCode = value.slice(0, 3);
      const prefix = value.slice(3, 6);
      const lineNumber = value.slice(6);

      return `(${areaCode}) ${prefix}-${lineNumber}`;
    }
  }
}
